import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PublicationSideBarComponent} from '@app/components/publications/publication-sideBar/publication-sideBar.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {PublicationLinksComponent} from './publication-links/publication-links.component';
import {DxDataGridModule, DxDropDownBoxModule, DxTreeViewModule} from 'devextreme-angular';
import {UtmEditorComponent} from './utm-editor/utm-editor.component';
import {RouterModule} from '@angular/router';
import {CintLinkComponent} from './publication-links/cint-link/cint-link.component';
import {RedirectLinksComponent} from './redirect-links/redirect-links.component';
import {InbeCommonsModule} from '@app/components/_common/inbe-commons.module';
import {IncidenceRateModule} from '@app/components/publications/incidence-rate/incidence-rate.module';
import {SurveysSelectorModule} from '../../../../@shared/surveys-selector/surveys-selector.module';
import {LoadingDirectiveModule} from '../../../../@shared/loading-directive/loading-directive.module';
import {UrlPlaceholderComponent} from "../../../../@shared/_generalTools/url-placeholder/url-placeholder.component";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatTabsModule} from "@angular/material/tabs";
import {MatSelectModule} from "@angular/material/select";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatInputModule} from "@angular/material/input";

@NgModule({
  declarations: [
    PublicationSideBarComponent,
    PublicationLinksComponent,
    UtmEditorComponent,
    CintLinkComponent,
    RedirectLinksComponent],
  exports: [
    PublicationSideBarComponent,
    CintLinkComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxDataGridModule,
    RouterModule,
    InbeCommonsModule,
    IncidenceRateModule,
    SurveysSelectorModule,
    LoadingDirectiveModule,
    UrlPlaceholderComponent,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
  ]
})
export class PublicationSideBarModule {
}
